<script>
export let number;
export let digits = 2;
export let parseCents = null;
export let classes = "";
export let classes_cents = "";
export let interval = "month";

let stringNumber = [];

function parse(number){
    number = new Intl.NumberFormat(['en-US'], {maximumFractionDigits: digits}).format(number);
    var splitter = number.split(".");
    if(typeof splitter[1] !== "undefined"){			
        if(splitter[1].length === 1){
            number += "0"; 
        }
    }
    parseCents = parseCents || null;
    if(parseCents === true){
        number = number.split(".");
        var string = `<span class="CurrencyFormatter ${classes}" data-number="${number.join("")}">
                <span class="CurrencyFormatter--price ${interval} ${classes}">
                    ${number[0]}
                </span>
                ${typeof number[1] !== "undefined" ? "." : ""}
                <span class="CurrencyFormatter--cents ${classes_cents}">
                    <span>
                        ${number[1] || ""}
                    </span>
                </span>
            </span>`
        return string;
    }
    return number;
}
stringNumber = parse(number);
$: {
    if(number){
        stringNumber = parse(number)
    }
}
</script>
<style>
.CurrencyFormatter--container :global(.CurrencyFormatter){
    display: inline-flex;
    align-items: baseline;
}
</style>
<span data-number="{number}" class="CurrencyFormatter--container">
    {@html stringNumber}
</span>